import React from 'react';

const Orders = () => {
   return (
       <div> Create a new category</div>
   )
}

export default Orders;